import { arrayOf, bool, func, shape, string } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import SignedCurrencyFormat from '../../generic/SignedCurrencyFormat';
import { opportunityShape, productShape, quoteShape } from '../../prop-types';
import { submit } from '../../quote-editor/actions';
import QuoteDownloadOptions from '../../quote-editor/QuoteDownloadOptions';
import UpdateQuote from '../../quote-editor/UpdateQuote.container';
import ProjectEntity from '../ProjectEntity';
import { ProjectEntityPropTypes } from '../ProjectEntity/ProjectEntity';

class ProjectQuote extends React.Component {
  handleSave = () => {
    this.props.onSubmit().then(this.props.entityProps.onSave);
  };

  renderProjectHeaderTitle = (primaryQuote, isQuoteDirty) => {
    return (
      <>
        <div className="d-flex align-items-center w-100">
          <h4 className="mb-0 mr-3">
            {primaryQuote.number} - {primaryQuote.campaignObjective}
          </h4>
          <h4 className="mb-0 mr-3">
            <SignedCurrencyFormat
              className="text-muted"
              name="netClientBudget"
              value={primaryQuote.netClientBudget}
            />
          </h4>
        </div>
        <div className="d-flex justify-content-end w-100">
          <QuoteDownloadOptions disabled={isQuoteDirty} quote={primaryQuote} />
        </div>
      </>
    );
  };

  render() {
    const {
      entityProps,
      isExpandable,
      modified,
      opportunity,
      quote,
      products,
      view,
    } = this.props;

    const { isEditing } = entityProps;

    return (
      <ProjectEntity
        title={this.renderProjectHeaderTitle(quote, modified)}
        {...entityProps}
        onSave={this.handleSave}
        onCancel={this.props.entityProps.onCancel}
        isExpandable={isExpandable}
      >
        <UpdateQuote
          opportunity={opportunity}
          quote={quote}
          isEditing={isEditing}
          products={products}
          view={view}
        />
      </ProjectEntity>
    );
  }
}

ProjectQuote.propTypes = {
  opportunityId: string.isRequired,
  onSubmit: func.isRequired,
  entityProps: shape(ProjectEntityPropTypes).isRequired,
  isExpandable: bool.isRequired,
  modified: bool.isRequired,
  opportunity: opportunityShape.isRequired,
  quote: quoteShape.isRequired,
  products: arrayOf(productShape).isRequired,
  view: string.isRequired,
};

const mapStateToProps = state => {
  return {
    modified: !!state.changeGuard,
  };
};

const mapDispatchToProps = {
  onSubmit: submit,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectQuote);
